import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { AgGridAngular } from "ag-grid-angular";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { RetailerService } from "src/app/features/retailers/retailer.service";
import { Module } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ActivatedRoute, Router } from "@angular/router";
import { InvoiceService } from "../invoice.service";
import { saveAs } from "file-saver";
import * as printJS from "print-js";
import { totalmem } from "os";
import { CurrencyPipe } from "@angular/common";
import { InvoiceDialogComponent } from "src/app/features-common/components/invoice-dialog/invoice-dialog.component";
import { MatDialog } from "@angular/material/dialog";

function actionCellRenderer(params) {
  let eGui = document.createElement("div");

  let editingCells = params.api.getEditingCells();
  // checks if the rowIndex matches in at least one of the editing cells
  let isCurrentRowEditing = editingCells.some((cell) => {
    return cell.rowIndex === params.node.rowIndex;
  });

  if (isCurrentRowEditing) {
    eGui.innerHTML = `
    <button  class="action-button update btn  btn-primary" type="button" data-action="update"> Update  </button>
    <button  class="action-button cancel btn  btn-warning" type="button" data-action="cancel" > Cancel </button>
    `;
  } else {
    eGui.innerHTML = `
    <button class=" action-button edit btn  btn-success" type="button" data-action="edit" > Edit  </button>
    <button class="action-button delete btn  btn-danger" type="button" data-action="delete" > Delete </button>
    `;
  }

  return eGui;
}
function numberParser(params) {
  return Number(params.newValue);
}
function floatParser(params) {
  return parseFloat(params.newValue);
}
@Component({
  selector: "app-edit-invoice",
  templateUrl: "./edit-invoice.component.html",
  styleUrls: ["./edit-invoice.component.scss"],
  providers: [CurrencyPipe],
})
export class EditInvoiceComponent
  extends FeaturesBaseComponent
  implements OnInit, OnDestroy
{
  @ViewChild("agGrid") agGrid: AgGridAngular;

  editInvoiceForm: FormGroup;
  // options: string[] = ['One', 'Two', 'Three'];
  filteredBusinessNameOptions: any[] = [];
  filteredRetailerAccNumOptions: any[] = [];
  lineItems;
  components;
  private gridApi;
  private gridColumnApi;
  public modules: Module[] = [ClientSideRowModelModule];
  columnDefs;
  defaultColDef;
  retailerDetails: any;
  retailerId: any;
  selectedOption: any;
  invoiceId: any;
  invoiceNumber: any;
  invoiceDetails: any;
  invoiceTotal: number = 0;
  newDate: Date = new Date();
  dueMinDate: Date = new Date();
  gridRowCount: number;
  disableSubmit: boolean = true;
  disablebuttons: boolean = true;

  currCellTotal: any;
  otherActions: boolean = true;
  itemsCodeData: any = [];
  invoiceStatus: any;
  invoiceType: any;

  constructor(
    private activeRoute: ActivatedRoute,
    private invoiceService: InvoiceService,
    private retailerService: RetailerService,
    private router: Router,
    private currencyPipe: CurrencyPipe,
    private dialog: MatDialog
  ) {
    super();
    this.invoiceService.getitemcodes().subscribe((res) => {
      if (res["httpcode"] == 200) {
        this.itemsCodeData = res["data"];
        this.columnDefs = [
          { field: "invoicRechargeId", headerName: "", width: 0, hide: true },
          {
            field: "itemCode",
            headerName: "Item Code",
            width: 180,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
              values: this.itemsCodeData,
            },
          },

          {
            field: "description",
            headerName: "Description",
            width: 160,
            cellEditorParams: { maxLength: 90 },
          },
          {
            field: "quantity",
            headerName: "Qty",
            valueParser: numberParser,
            width: 90,
            type: "valueColumn",
          },
          /*{
            field: 'price', headerName: 'Price', width: 130, type: 'valueColumn', valueParser: floatParser, cellRenderer: (data) => {
              return this.currencyPipe.transform(data.value)} },*/
          {
            field: "total",
            headerName: "Total",
            //valueGetter:'getValue("quantity") * getValue("price")',
            width: 140,
            //editable: false ,
            cellRenderer: (data) => {
              return this.currencyPipe.transform(data.value);
            },
          },
          {
            headerName: "Action",
            minWidth: 150,
            cellRenderer: actionCellRenderer,
            editable: false,
            colId: "action",
          },
        ];
      }
    });
    // AG Grid init
    this.defaultColDef = {
      editable: true,
    };
    this.lineItems = [];

    // initialize form
    this.initForm();
    // store current invoice id
    this.invoiceId = this.activeRoute.snapshot.params.id;

    // get all business name details
    this.retailerService.getRetailerBusinessNames().subscribe((res) => {
      if (res["httpcode"] == 200) {
        this.retailerDetails = res["data"];
        this.filteredBusinessNameOptions = this.retailerDetails;
        this.filteredRetailerAccNumOptions = this.retailerDetails;
        // get incoice by Id
        this.invoiceService.getInvoicebyId(this.invoiceId).subscribe((res) => {
          this.invoiceDetails =
            res["httpcode"] == 200 && res["data"] ? res["data"] : [];
          this.invoiceNumber = res["data"].invoiceDetails.invoiceNumber;
         

          if (this.invoiceDetails && this.invoiceDetails) {
           
            this.retailerId = this.invoiceDetails.invoiceDetails.retailerId;
            this.invoiceStatus = this.invoiceDetails.invoiceDetails.invoiceStatus;
            this.invoiceType = this.invoiceDetails.invoiceDetails.invoiceType;
           
            this.invoiceTotal =
              this.invoiceDetails.invoiceDetails.invoiceAmount;

            setTimeout(() => {
              // get curretnt retailer detailer by id
              let retailerDetails = this.retailerDetails.filter(
                (x) => x.retailerId == this.retailerId
              )[0];

             

              // update form with  current retailer details
              this.updateFormValues(
                this.invoiceDetails.invoiceDetails,
                retailerDetails
              );
            }, 50);
          }
          // add rowData to Ag-Grid
          this.lineItems = this.invoiceDetails.invoiceLineItems;
        });
      }
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.onAutoSelectChanges();
    this.editInvoiceForm.valueChanges.subscribe(() => {
      this.disableSubmit =
        this.editInvoiceForm.valid && this.invoiceTotal > 0 ? false : true;
        this.disablebuttons =
        this.editInvoiceForm.valid ? false : true;  
          
      this.otherActions = true;
    });
  }

  onAutoSelectChanges() {
    this.editInvoiceForm.get("businessName").valueChanges.subscribe((res) => {
      let businessName: string;
      businessName = res.businessName ? res.businessName : res;
      this.filteredBusinessNameOptions = this.retailerDetails;
      this.filteredBusinessNameOptions = res
        ? this._filterBusinessNames(businessName)
        : this.retailerDetails.slice();
    });
    this.editInvoiceForm.get("accountNo").valueChanges.subscribe((res) => {
      let accountNo: string;
      accountNo = res.retailerAccountNumber ? res.retailerAccountNumber : res;
      this.filteredRetailerAccNumOptions = this.retailerDetails;
      this.filteredRetailerAccNumOptions = res
        ? this._filterRetailerAccNum(accountNo)
        : this.retailerDetails.slice();
    });
  }

  private _filterBusinessNames(businessName: any): any {
    const filterValue = businessName.replace(/\s/g, "").toLowerCase();
    return this.retailerDetails.filter((option) =>
      option && option.businessName
        ? option?.businessName
            .toLowerCase()
            .replace(/\s/g, "")
            .indexOf(filterValue) === 0
        : false
    );
  }

  getOptionBusinessName(option) {
    return option && option ? option.businessName : "";
  }

  selectedBusinessNameDetails(e) {
    this.selectedOption = e.option.value;
    if (this.selectedOption && this.selectedOption) {
      this.editInvoiceForm.patchValue({
        accountNo: this.selectedOption,
        businessName: this.selectedOption,
        businessAddress1: this.selectedOption.address,
        retailerEmail: this.selectedOption.email,
      });
      this.retailerId = this.selectedOption.retailerId;
      return;
    }
  }

  private _filterRetailerAccNum(accountNo: string): any[] {
    const filterValue =
      accountNo && accountNo ? accountNo.replace(/\s/g, "").toLowerCase() : "";
    return this.retailerDetails.filter((option) =>
      option && option.retailerAccountNumber
        ? option?.retailerAccountNumber
            .toLowerCase()
            .replace(/\s/g, "")
            .indexOf(filterValue) === 0
        : false
    );
  }

  getOptionRetailerAccNum(option) {
    return option && option ? option.retailerAccountNumber : "";
  }

  selectedRetailerAccNum(e) {
   
    this.selectedOption = e.option.value;
    if (this.selectedOption && this.selectedOption) {
      this.editInvoiceForm.patchValue({
        accountNo: this.selectedOption,
        businessName: this.selectedOption,
        businessAddress1: this.selectedOption.address,
        retailerEmail: this.selectedOption.email,
      });
      this.retailerId = this.selectedOption.retailerId;
    }
  }

  initForm() {
    this.editInvoiceForm = new FormGroup({
      accountNo: new FormControl(""),
      retailerEmail: new FormControl(""),
      businessName: new FormControl(""),
      businessAddress1: new FormControl(""),
      issuedDate: new FormControl(""),
      dueDate: new FormControl(""),
      comments: new FormControl(""),
    });
  }

  get f() {
    return this.editInvoiceForm.controls;
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onSubmit() {}

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onCellClicked(params) {
    this.otherActions = false;

    // Handle click event for action cells
    if (
      params.column.colId === "action" &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;

      if (action === "edit") {
        params.api.startEditingCell({
          rowIndex: params.node.rowIndex,
          // gets the first columnKey
          colKey: params.columnApi.getDisplayedCenterColumns()[0].colId,
        });
      }

      if (action === "delete") {
        params.api.applyTransaction({
          remove: [params.node.data],
        });

        this.disableSubmit =
          this.gridApi.getDisplayedRowCount() === 0 ? true : false;
        this.disablebuttons =
          this.gridApi.getDisplayedRowCount() === 0 ? true : false;  
            
        this.invoiceTotal =
          this.gridApi.getDisplayedRowCount() === 0
            ? this.gridApi.getDisplayedRowCount()
            : this.invoiceTotal;
      }

      if (action === "update") {
        params.api.stopEditing(false);
      }

      if (action === "cancel") {
        params.api.stopEditing(true);
      }
    }
    this.getGridDataValues();
  }

  getGridDataValues() {
    // get all grid rows data
    let items: Array<any> = [];
    this.gridApi.forEachNode((node) => {
      items.push(node.data);
     
     
      this.invoiceTotal = 0;
      items.forEach((item) => {
        this.invoiceTotal += Number(item.total);
        this.disableSubmit =
          this.invoiceTotal > 0 && this.editInvoiceForm.valid ? false : true;
        this.disablebuttons =
          this.editInvoiceForm.valid ? false : true;  
            
      });
    });
  }

  onRowEditingStarted(params) {
    params.api.refreshCells({
      columns: ["action"],
      rowNodes: [params.node],
      force: true,
    });
  }
  onRowEditingStopped(params) {
    params.api.refreshCells({
      columns: ["action"],
      rowNodes: [params.node],
      force: true,
    });
    if (!(this.invoiceTotal > 0)) {
      this.toastrService.warning(
        "Please check the line item values entered.",
        "Invalid line items"
      );
    }
  }

  addRow() {
    this.gridApi.updateRowData({
      add: [
        {
          invoicRechargeId: null,
          itemCode: "",
          description: "",
          quantity: 1,
          total: 0,
        },
      ],
    });
    this.otherActions = false;
    this.disableSubmit =
      this.invoiceTotal > 0 && this.editInvoiceForm.valid ? false : true;
    this.disablebuttons =
      this.editInvoiceForm.valid ? false : true;  
  }

  onUpdateInvoice(e) {
    this.getGridDataValues();
   
    if (this.editInvoiceForm.invalid) {
      return;
    }
    this.invoiceService.updateInvoice(this.setFormData()).subscribe((res) => {
      if (res["httpcode"] == 200) {
        this.toastrService.success(
          `Invoice #${this.invoiceNumber} updated successfully`,
          "Success",
          { timeOut: 2000 }
        );

        // let invoiceId = res['data'].invoiceId;
        this.router.navigate([
          `features/reports/invoices/invoice-preview/${this.invoiceId}`,
        ]);
      }
    });
  }

  setFormData() {
    let items: Array<any> = [];
    this.gridApi.forEachNode((node) => {
      items.push(node.data);
     
    });
   
   
   
    let invcStrtDt = this.editInvoiceForm.get("issuedDate").value;
    let invcDueDt = this.editInvoiceForm.get("dueDate").value;
    let formData = {
      invoice: {
        invoiceId: parseInt(this.invoiceId),
        retailerId: this.retailerId,
        invoiceAmount: this.invoiceTotal,
        invoiceComments: this.editInvoiceForm.get("comments").value,
        invoiceDate: invcStrtDt,
        paymentDueDate: invcDueDt,
        invoiceNumber: this.invoiceNumber,
        // "invoiceReason": this.invoiceDetails.invoiceDetails.invoiceReason,
        // "invoiceStatus": this.invoiceDetails.invoiceDetails.invoiceStatus,
        // "retailerBusinessName": this.editInvoiceForm.get('businessName').value.businessName,
        // "createdBy": this.invoiceDetails.invoiceDetails.createdBy,
        // "createdDttm": this.invoiceDetails.invoiceDetails.createdDttm,
      },
      invoiceLineItems: items,
      retailerId: this.retailerId,
    };

    // formData['invoiceLineItems'] = items;
   
    return formData;
  }

  // update for with values from invoice details by id
  updateFormValues(invoiceDetails, retailerDetails) {
   
    this.editInvoiceForm.patchValue({
      accountNo: retailerDetails,
      businessName: retailerDetails,
      businessAddress1: retailerDetails.address,
      retailerEmail: retailerDetails.email,
      issuedDate: invoiceDetails.invoiceDate,
      dueDate: invoiceDetails.paymentDueDate,
      comments: invoiceDetails.invoiceComments,
    });
    this.newDate = invoiceDetails.invoiceDate;
  }
  // Preview invoice before save
  previewBeforeSave() {
    if (this.editInvoiceForm.invalid) {
      return;
    }
    this.invoiceService
      .previewBeforeSave(this.setFormData())
      .subscribe((res) => {
        let data: any = res;
        var file = new Blob([data], { type: "application/pdf" });
        // set preview url
        var fileURL = URL.createObjectURL(file);
        const dialogRef = this.dialog.open(InvoiceDialogComponent, {
          panelClass: "preview-panel",
          data: {
            fileURL: fileURL,
          },
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
          if (confirmed) {
           
          }
        });
      });
  }
  // Download Invoice by Id
  downloadInvoice() {
    this.invoiceService.getInvoicePdf(this.invoiceId).subscribe((res) => {
      //;
      // trigger download
      saveAs(res, "tila_invoice.pdf");
    });
  }
  // Send via email the PDF
  sendViaEmail() {
   
   
    if (!this.disableSubmit && !this.otherActions) {
      this.toastrService.warning(`Unsaved changes`, "Warning");
      return;
    }
    this.router.navigate([
      `features/reports/invoices/email-preview/${this.invoiceId}`,
    ]);
  }

  //Print Invoice by Id
  onPrintInvoice() {
    this.invoiceService.getInvoicePdf(this.invoiceId).subscribe((res) => {
      let data: any = res;
      var file = new Blob([data], { type: "application/pdf" });
      // set preview url
      var fileURL = URL.createObjectURL(file);
      printJS({ printable: `${fileURL}`, type: "pdf", showModal: true });
    });
  }
}
